import { render, staticRenderFns } from "./PopupBarcode.vue?vue&type=template&id=8881b72e"
import script from "./PopupBarcode.vue?vue&type=script&lang=js"
export * from "./PopupBarcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports